module.exports = __webpack_public_path__ + "img/logo_grey.37e9af80.svg";